export default __webpack_public_path__ + "static/media/calendar-icon.88cb8e79.svg";